module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    class: {
      'flex': _vm.flex, 'aside': _vm.aside
    }
  }, [_c('ext-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": _vm.to
    }
  }, [_c('h3', {
    staticClass: "sidebar__title ui_lines-limit-3",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _c('img', {
    staticClass: "sidebar__img",
    attrs: {
      "src": _vm.middleThumb,
      "alt": _vm.title
    }
  })]), _c('div', {
    staticClass: "sidebar__event_type ui_lines-limit-3"
  }, [_vm._v(_vm._s(_vm.getEventType))]), _c('div', {
    staticClass: "sidebar__desc ui_lines-limit-3"
  }, [_vm._v(_vm._s(_vm.desc))]), _c('div', {
    staticClass: "sidebar__footer"
  }, [_c('div', {
    staticClass: "sidebar__footer_col"
  }, [_c('div', {
    staticClass: "sidebar__footer_view"
  }, [_vm._v(_vm._s(_vm.view))])]), _c('div', {
    staticClass: "sidebar__footer_col"
  }, [_c('div', {
    staticClass: "sidebar__footer_comments"
  }, [_vm._v(_vm._s(_vm.comments))])]), _c('div', {
    staticClass: "sidebar__footer_col"
  }, [_c('button-default', {
    attrs: {
      "color": "green",
      "to": _vm.to
    }
  }, [_vm._v("Прочитать")])], 1)]), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c085247","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/blog/list/components/Item.vue
// module id = dd96354c56bc66d22758
// module chunks = 0